import React from "react";

import ViewAppBar from "../views/ViewAppBar";

import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";
import ViewPreferenciaMensagem from "../views/ViewPreferenciaMensagem";

const PreferenciaMensagem: React.FC = () => (
  <>
    <ContatoZap />

    <ViewAppBar />

    <ViewPreferenciaMensagem />
    <ViewFooter />
  </>
);
export default PreferenciaMensagem;
